<template>
  <div id="loginTop">
    <img src="@/assets/img/logo.png">
    <div class="flex-grow"></div>
    <div class="action">
      <span v-for="locale in $ts.getters.getLocales" :key="locale" class="locale" :class="{active: $ts.state.locale === locale}" @click="$ts.commit('setLocale', locale)">
        {{ locale.toUpperCase() }}
      </span>
    </div>
  </div>
</template>

<script>
  import ActionMenu from "@/components/tools/ActionMenu.vue";

  export default {
    name: "LoginTop",
    components: { ActionMenu }
  };
</script>

<style lang="scss" scoped>

  #loginTop {
    background-color: #ffffff;
    height: 80px;
    display: flex;
    align-items: center;
    padding: 0px 30px;
    .action {
      margin-left: 20px;
      height: 20px;
      cursor: pointer;
    }
  }

  .flex-grow {
    flex-grow: 1;
  }

  .locale {
    margin: 0 4px;
    &.active {
      font-weight: bold;
    }
  }

</style>
